import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props, d as defaults } from './componentEl-33ff2aeb.js';
import { S as SpacerSmd, a as SpacerMd, b as SpacerMlg, c as SpacerLg, d as SpacerXl } from './_variables.es6-3122d3a2.js';

function Avatar(_ref) {
  let {
    componentEl: Component,
    avatar,
    initials,
    className,
    margin,
    size
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "avatar", "initials", "children", "className", "margin", "size"]);

  // state for image error
  const [error, setError] = useState(false);

  function onError() {
    setError(true);
  } // given a width and an array of images
  // returns image with closest size to desired width


  function closestImage(width, images) {
    return images.reduce((closest, thisone) => {
      if (Math.abs(width - thisone.width) < Math.abs(width - closest.width)) {
        return thisone;
      }

      return closest;
    }, images[0]);
  } // if there's no images or a name, don't do anything


  if (!avatar && !initials) return null;
  let cssClasses = ['st_avatar', "st_avatar--" + size];
  cssClasses = addClassNames(className, cssClasses);
  const imageAttributes = {};
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });

  if (avatar && typeof avatar === 'string') {
    imageAttributes.src = avatar;
  } else if (avatar && Array.isArray(avatar)) {
    // TODO: read from design tokens!!!
    const sizes = {
      smd: SpacerSmd,
      md: SpacerMd,
      mlg: SpacerMlg,
      lg: SpacerLg,
      xl: SpacerXl
    };
    const sizedAvatar = closestImage(sizes[size], avatar);
    const sizedAvatar2x = closestImage(sizes[size] * 2, avatar);
    imageAttributes.src = sizedAvatar.url;
    imageAttributes.srcSet = sizedAvatar.url + ", " + sizedAvatar2x.url + " 2x";
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/React.createElement(React.Fragment, null, avatar && !error && /*#__PURE__*/React.createElement("img", _extends({
    className: "st_avatar__img"
  }, imageAttributes, {
    loading: "lazy",
    alt: "",
    onError: onError
  })), (!avatar || error) && /*#__PURE__*/React.createElement("span", {
    className: "st_avatar__letter"
  }, initials)));
}

Avatar.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** array of available avatar images, or url to single image */
  avatar: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number,
    url: PropTypes.string
  })), PropTypes.string]),

  /** fallback letter */
  initials: PropTypes.string,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for avatar, if any */
  margin: marginProps,

  /** size of avatar */
  size: PropTypes.oneOf(['smd', 'md', 'mlg', 'lg', 'xl'])
};
Avatar.defaultProps = {
  componentEl: defaults,
  avatar: null,
  initials: null,
  className: null,
  margin: null,
  size: 'mlg'
};

export default Avatar;
